/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { Fragment, useState } from '@wordpress/element';
import { InspectorControls, BlockControls } from '@wordpress/block-editor';
import { PanelBody, QueryControls, FormTokenField, SelectControl, ToggleControl, RangeControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import Slider from "react-slick";
import './../../assets/slick/slick.css';
import './../../assets/slick/slick-theme.css';


export default function Edit( props ) {

	const termsQuery = { post_type: 'itineraries', per_page: 100 };

	const tripTypes = useSelect( ( select ) => {
		return select( 'core' ).getEntityRecords( 'taxonomy', 'itinerary_types', termsQuery );
	}, [] );

	const tripDestinations = useSelect( ( select ) => {
		return select( 'core' ).getEntityRecords( 'taxonomy', 'travel_locations', termsQuery );
	}, [] );

	const tripActivities = useSelect( ( select ) => {
		return select( 'core' ).getEntityRecords( 'taxonomy', 'activity', termsQuery );
	}, [] );

	const tripKeywords = useSelect( ( select ) => {
		return select( 'core' ).getEntityRecords( 'taxonomy', 'travel_keywords', termsQuery );
	}, [] );

	const { setAttributes, attributes } = props;
	const { query, saleTrip, featuredTrip, sliderHeight, layoutType, sliderDots, sliderArrow, sliderAutoplay  } = attributes;
	const {
		orderBy,
		order,
		selectedTripTypes,
		selectedTripDestinations,
		selectedTripActivities,
		selectedTripKeywords,
		numberOfItems,
	} = query;

	const sliderPram = {
		query: props.attributes.query,
		featuredTrip: props.attributes.featuredTrip,
		saleTrip: props.attributes.saleTrip,
		sliderArrow: props.attributes.sliderArrow,
		sliderAutoplay: props.attributes.sliderAutoplay,
		sliderDots: props.attributes.sliderDots,
		sliderHeight: props.attributes.sliderHeight
	}

	const TripTypeSuggestions = tripTypes?.reduce(
		(accumulator, category) => ({
			...accumulator,
			[category.name]: category,
		}),
		{}
	) ?? {};

	let selected_trip_types = [];
	if (selectedTripTypes && selectedTripTypes.length > 0) {
		selected_trip_types = selectedTripTypes.map((type) => {
			return type.name;
		})
	}

	const TripDestinationSuggestions = tripDestinations?.reduce(
		(accumulator, category) => ({
			...accumulator,
			[category.name]: category,
		}),
		{}
	) ?? {};
	let selected_trip_destinations = [];
	if (selectedTripDestinations && selectedTripDestinations.length > 0) {
		selected_trip_destinations = selectedTripDestinations.map((type) => {
			return type.name;
		})
	}

	const TripActivitySuggestions = tripActivities?.reduce(
		(accumulator, category) => ({
			...accumulator,
			[category.name]: category,
		}),
		{}
	) ?? {};
	let selected_trip_activities = [];
	if (selectedTripActivities && selectedTripActivities.length > 0) {
		selected_trip_activities = selectedTripActivities.map((type) => {
			return type.name;
		})
	}

	const TripKeywordSuggestions = tripKeywords?.reduce(
		(accumulator, category) => ({
			...accumulator,
			[category.name]: category,
		}),
		{}
	) ?? {};
	let selected_trip_keywords = [];
	if (selectedTripKeywords && selectedTripKeywords.length > 0) {
		selected_trip_keywords = selectedTripKeywords.map((type) => {
			return type.name;
		})
	}
	const settings = {
		dots: true,
		arrows: true,
		autoplay: false,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1
	  };

const [ tripLists, setTripLists ] = useState( [] );
	useSelect( () => {
        fetch( _wp_travel.site_url + '/wp-json/wptravel/v1/get-slider-trips?param=' + JSON.stringify(sliderPram), {
			method: "GET"
		  }).then((res) => res.json())
			.then((data) => {
				setTripLists( data )
			})
			.catch((err) => console.error(err));
    }, [] );

	
	const onChangeItemNumber = (newNumberOfItems) => {

		sliderPram.query = {
			...query,		
			numberOfItems: newNumberOfItems,
		}

        fetch( _wp_travel.site_url + '/wp-json/wptravel/v1/get-slider-trips?param=' + JSON.stringify(sliderPram), {
			method: "GET"
		  }).then((res) => res.json())
			.then((data) => {
				if( data !== tripLists ){
					setTripLists( data )
				}else{
					setTripLists( tripLists )
				}

				setAttributes({
					query: {
						...query,
						numberOfItems: newNumberOfItems,
					},
				})
			} )
			.catch((err) => console.error(err));
			
 	}

	 const onChangeOrder = (newOrderBy, newOrder) => {
		sliderPram.query = {
			...query,		
			orderBy: newOrderBy,
			order: newOrder,
		}

        fetch( _wp_travel.site_url + '/wp-json/wptravel/v1/get-slider-trips?param=' + JSON.stringify(sliderPram), {
			method: "GET"
		  }).then((res) => res.json())
			.then((data) => {
				if( data !== tripLists ){
					setTripLists( data )
				}else{
					setTripLists( tripLists )
				}

				setAttributes({
						query: {
							...query,
							orderBy: newOrderBy,
							order: newOrder,
						},
					})
			} )
			.catch((err) => console.error(err));
			
 	}

 	const onChangeTripTypes = (tokens) => {
 		const allCategories = tokens.map((token) => {
			const newData  = typeof token === 'string' ? TripTypeSuggestions[ token ] : token;
			const selected = {
				count: newData.count,
				id: newData.id,
				description: newData.description,
				link: newData.link,
				taxonomy: newData.taxonomy,
				name: newData.name,
				slug: newData.slug,
			}
			return selected;
		} );

 		sliderPram.query = {
			...query,		
			selectedTripTypes: allCategories,
		}

		fetch( _wp_travel.site_url + '/wp-json/wptravel/v1/get-slider-trips?param=' + JSON.stringify(sliderPram), {
			method: "GET"
		  }).then((res) => res.json())
			.then((data) => {
				if( data !== tripLists ){
					setTripLists( data )
				}else{
					setTripLists( tripLists )
				}

				setAttributes({
					query: {
						...query,
						selectedTripTypes: allCategories,
					},
				} )
			} )
			.catch((err) => console.error(err));
 	}

 	const onChangeTripDestinations = (tokens) => {
 		const allCategories = tokens.map((token) => {
			const newData  = typeof token === 'string' ? TripDestinationSuggestions[ token ] : token;
			const selected = {
				count: newData.count,
				id: newData.id,
				description: newData.description,
				link: newData.link,
				taxonomy: newData.taxonomy,
				name: newData.name,
				slug: newData.slug,
			}
			return selected;
		} );

 		sliderPram.query = {
			...query,		
			selectedTripDestinations: allCategories,
		}

		fetch( _wp_travel.site_url + '/wp-json/wptravel/v1/get-slider-trips?param=' + JSON.stringify(sliderPram), {
			method: "GET"
		  }).then((res) => res.json())
			.then((data) => {
				if( data !== tripLists ){
					setTripLists( data )
				}else{
					setTripLists( tripLists )
				}

				setAttributes({
					query: {
						...query,
						selectedTripDestinations: allCategories,
					},
				} )
			} )
			.catch((err) => console.error(err));

 	}

 	const onChangeTripActivity = (tokens) => {
 		const allCategories = tokens.map((token) => {
			const newData  = typeof token === 'string' ? TripActivitySuggestions[ token ] : token;
			const selected = {
				count: newData.count,
				id: newData.id,
				description: newData.description,
				link: newData.link,
				taxonomy: newData.taxonomy,
				name: newData.name,
				slug: newData.slug,
			}
			return selected;
		} );

 		sliderPram.query = {
			...query,		
			selectedTripActivities: allCategories,
		}

		fetch( _wp_travel.site_url + '/wp-json/wptravel/v1/get-slider-trips?param=' + JSON.stringify(sliderPram), {
			method: "GET"
		  }).then((res) => res.json())
			.then((data) => {
				if( data !== tripLists ){
					setTripLists( data )
				}else{
					setTripLists( tripLists )
				}

				setAttributes({
					query: {
						...query,
						selectedTripActivities: allCategories,
					},
				} )
			} )
			.catch((err) => console.error(err));

 	}

 	const onChangeTripKeywords = (tokens) => {
 		const allCategories = tokens.map((token) => {
			const newData  = typeof token === 'string' ? TripKeywordSuggestions[ token ] : token;
			const selected = {
				count: newData.count,
				id: newData.id,
				description: newData.description,
				link: newData.link,
				taxonomy: newData.taxonomy,
				name: newData.name,
				slug: newData.slug,
			}
			return selected;
		} );

 		sliderPram.query = {
			...query,		
			selectedTripActivities: allCategories,
		}

		fetch( _wp_travel.site_url + '/wp-json/wptravel/v1/get-slider-trips?param=' + JSON.stringify(sliderPram), {
			method: "GET"
		  }).then((res) => res.json())
			.then((data) => {
				if( data !== tripLists ){
					setTripLists( data )
				}else{
					setTripLists( tripLists )
				}

				setAttributes({
					query: {
						...query,
						selectedTripActivities: allCategories,
					},
				} )
			} )
			.catch((err) => console.error(err));

 	}

 	const onChangeSaleTrip = () => { 
 		sliderPram.saleTrip = ! saleTrip;
 		fetch( _wp_travel.site_url + '/wp-json/wptravel/v1/get-slider-trips?param=' + JSON.stringify(sliderPram), {
			method: "GET"
		  }).then((res) => res.json())
			.then((data) => {
				if( data !== tripLists ){
					setTripLists( data )
				}else{
					setTripLists( tripLists )
				}

				setAttributes( { saleTrip: ! saleTrip } )
			} )
			.catch((err) => console.error(err));
 	}

 	const onChangeFeaturedTrip = () => { 
 		sliderPram.featuredTrip = ! featuredTrip;
 		fetch( _wp_travel.site_url + '/wp-json/wptravel/v1/get-slider-trips?param=' + JSON.stringify(sliderPram), {
			method: "GET"
		  }).then((res) => res.json())
			.then((data) => {
				if( data !== tripLists ){
					setTripLists( data )
				}else{
					setTripLists( tripLists )
				}

				setAttributes( { featuredTrip: ! featuredTrip } )
			} )
			.catch((err) => console.error(err));
 	}
 
	return (
		<div { ...useBlockProps() }>
			<Fragment>
				<InspectorControls>
					<PanelBody title={__('Slider Options', 'wp-travel-blocks')}>
						<SelectControl
							label={__('Select Layout', 'wp-travel-blocks')}
							value={layoutType}
							options={ [
								{
									label: __('Design One', 'wp-travel-blocks'),
									value: 'design-one'
								},
								{
									label: __('Design Two', 'wp-travel-blocks'),
									value: 'design-two'
								}, {
									label: __('Design Three', 'wp-travel-blocks'),
									value: 'design-three'
								}
							] }
							onChange={(val) => setAttributes({ layoutType: val })}
						/>
						<RangeControl
							label={__('Slider Height', 'wp-travel-blocks')}
							value={ sliderHeight }
							onChange={ ( value ) => setAttributes( { sliderHeight: value } ) }
							min={ 20 }
							max={ 1000 }
						/>
						{/* <QueryControls
							{...{ orderBy, order, numberOfItems }}
							onNumberOfItemsChange={(newNumberOfItems) => {
								onChangeItemNumber( newNumberOfItems )
							}
							}
						/> */}
						<SelectControl
							label={__('Order by', 'wp-travel-blocks')}
							value={ orderBy + '/' + order }
							options={ [
								{
									label: __('Newest to oldest', 'wp-travel-blocks'),
									value:'date/desc'
								}, {
									label: __('Oldest to newest', 'wp-travel-blocks'),
									value:'date/asc'
								}, {
									label: __('A → Z', 'wp-travel-blocks'),
									value:'title/asc'
								}, {
									label: __('Z → A', 'wp-travel-blocks'),
									value:'title/desc'
								}
							] }
							onChange={ ( selectedVal ) => {
								let values = selectedVal.split( '/' );
								let newOrderBy = values[0];
								let newOrder = values[1];
								onChangeOrder(newOrderBy,newOrder)
							} }
						/>
						<FormTokenField
							label={__('Trip Type', 'wp-travel-blocks')}
							value={selected_trip_types ?? []}
							suggestions={Object.keys(TripTypeSuggestions).map(name => { return name })}
							onChange={ tokens => {
								onChangeTripTypes( tokens )								
							} }
						/>
						<FormTokenField
							label={ __('Trip Destinations', 'wp-travel-blocks') }
							value={ selected_trip_destinations ?? [] }
							suggestions={Object.keys(TripDestinationSuggestions).map(name => { return name })}
							onChange={ tokens => {
								onChangeTripDestinations( tokens )	
							}}
						/>

						<FormTokenField
							label={ __('Trip Activities', 'wp-travel-blocks') }
							value={ selected_trip_activities ?? [] }
							suggestions={Object.keys(TripActivitySuggestions).map(name => { return name })}
							onChange={tokens => {
								onChangeTripActivity(tokens)
							}}
						/>
						<FormTokenField
							label={ __('Trip Keywords', 'wp-travel-blocks') }
							value={ selected_trip_keywords ?? [] }
							suggestions={ Object.keys(TripKeywordSuggestions).map(name => { return name }) }
							onChange={ tokens => {
								onChangeTripKeywords(tokens)
							}}
						/>
						<ToggleControl
							label={ __( 'Sale Trip', 'wp-travel-blocks' ) }
							checked={ saleTrip }
							onChange={ () => {
								onChangeSaleTrip()
							} }
						/>
						<ToggleControl
							label={ __( 'Featured Trip', 'wp-travel-blocks' ) }
							checked={ featuredTrip }
							onChange={ () => {
								onChangeFeaturedTrip()
							} }
						/>
					</PanelBody>
				</InspectorControls>
			</Fragment>

			{ 
				layoutType == 'design-one' && 
				<div id="wptravel-block-trip-slider" className='wptravel-block-trip-slider'>
				
					<Slider 
						className='wp-travel-trip-slider'
						style={
							{height: sliderHeight+"px"}
						}
						{...settings}
					>
					{
						tripLists.map( ( data ) =>{
							return (
								<div className="item">
									<div className="overlay"></div>
									<img 
										src={data.image} 
										alt={data.title}
										style={
											{height: sliderHeight+"px"}
										}
									/>
									<div className="wp-travel-entry-content">
										<div className="trip-title">
											<h2>{data.title}</h2>
										</div>
										<div className="trip-price">
											<span className="price-from">
											{ __( 'From', 'wp-travel-blocks' ) }
											</span>
											<span className="person-count">
												<ins>
													<span>
														<span className="wp-travel-trip-price-figure">100.00</span> 
														<span className="wp-travel-trip-currency">$</span>
													</span>
												</ins>
											</span>
										</div>
										<div className="trip-excerpt">
											<p>{data.excerpt}</p>
										</div>
										<div className="read-more">
											<a href="{data.url}" className="btn">Book Now</a>
										</div>
									</div>
								</div>
							);
						} ) 
					}
					{
						( tripLists.length <= 0 ) && 
						<div className="wptravel-block-notice">
							<i className="fa fa-info-circle"></i>
							<span>No Trips Found! Make sure you have trips set up for selected filter.</span>
						</div>
					}
					</Slider>
				</div>
			}

			{ 
				layoutType == 'design-two' && 
				<div id="wptravel-block-trip-slider" className='wptravel-block-trip-slider design-two'>
				
					<Slider 
						className='wp-travel-trip-slider'
						style={
							{height: sliderHeight+"px"}
						}
						{...settings}
					>
					{
						tripLists.map( ( data ) =>{
							return (
								<div className="item">
									<div className="overlay"></div>
									<img 
										src={data.image} 
										alt={data.title}
										style={
											{height: sliderHeight+"px"}
										}
									/>
									<div className="wp-travel-entry-content">
										
										<div className="trip-title">
											<div className="wptravel-blocks-trip-meta">
												<a href="#" tabindex="0">
													Nepal											
												</a>
											</div>
											<h2>{data.title}</h2>
											<div className="wptravel-blocks-trip-rating">
												<span class="fa fa-star checked"></span>
												<span class="fa fa-star checked"></span>
												<span class="fa fa-star checked"></span>
												<span class="fa fa-star"></span>
												<span class="fa fa-star"></span>
											</div>

										</div>
										
										<div className="trip-excerpt">
											<p>{data.excerpt}</p>
										</div>
										<div className="trip-price">
											<span className="price-from">
											{ __( 'From', 'wp-travel-blocks' ) }
											</span>
											<span className="person-count">
												<ins>
													<span>
														<span className="wp-travel-trip-price-figure">100.00</span> 
														<span className="wp-travel-trip-currency">$</span>
													</span>
												</ins>
											</span>
										</div>
										<div className="read-more">
											<a href="{data.url}" className="btn">Book Now</a>
										</div>
									</div>
								</div>
							);
						} ) 
					}
					{
						( tripLists.length <= 0 ) && 
						<div className="wptravel-block-notice">
							<i className="fa fa-info-circle"></i>
							<span>No Trips Found! Make sure you have trips set up for selected filter.</span>
						</div>
					}
					</Slider>
				</div>
			}

			{ 
				layoutType == 'design-three' && 
				<div id="wptravel-block-trip-slider" className='wptravel-block-trip-slider design-three'>
				
					<Slider 
						className='wp-travel-trip-slider'
						style={
							{height: sliderHeight+"px"}
						}
						{...settings}
					>
					{
						tripLists.map( ( data ) =>{
							return (
								<div className="item">
									<div className="overlay"></div>
									<img 
										src={data.image} 
										alt={data.title}
										style={
											{height: sliderHeight+"px"}
										}
									/>
									<div className="wp-travel-entry-content">
										
										<div className="trip-title">
											<div class="wptravel-blocks-trip-rating">
												<i class="fas fa-star"></i> 5 out of 5									
											</div>
											<div class="trip-price">
												<span class="price-from">
													From										
												</span>
												<span class="person-count">
													<ins>
														<span>			
															<span class="wp-travel-trip-price-figure">108.0000</span><span class="wp-travel-trip-currency">$</span>
														</span>
													</ins>
												</span>
											</div>
											<h2>{data.title}</h2>
											<div class="wptravel-blocks-trip-meta">
												<div class="wptravel-blocks-trip-meta-location">
													<i class="fas fa-map-marker-alt"></i>
													<a href="http://optimize.local/travel-locations/nepal/" tabindex="0">
														Nepal												
													</a>
												</div>
												<div class="wptravel-blocks-trip-meta-detarture-date">
													<i class="far fa-calendar-alt"></i> 6 Days											
												</div>
												<div class="wptravel-blocks-trip-meta-group">
													<i class="fas fa-users"></i> 15										
												</div>
											</div>

										</div>
										
										<div className="trip-excerpt">
											<p>{data.excerpt}</p>
										</div>
										
										<div className="read-more">
											<a href="{data.url}" className="btn">Book Now</a>
										</div>
									</div>
								</div>
							);
						} ) 
					}
					{
						( tripLists.length <= 0 ) && 
						<div className="wptravel-block-notice">
							<i className="fa fa-info-circle"></i>
							<span>No Trips Found! Make sure you have trips set up for selected filter.</span>
						</div>
					}
					</Slider>
				</div>
			}

			
		</div>
	);
}